import React from 'react'
import { features } from 'helpers/constants'
import {t} from "helpers/language"

export const skill = {
  key: "POPULATE_QUOTE",
  group: 'quoting',
  label: t("Populate your quote"),
  desc: t("Populate your quote ready to send to your customer"),
  feature: features.QUOTING_LICENCE,
  steps: [
    {
      target: '.viewQuotesContainer',
      content: <div>To begin, open a quote by clicking on it in the list</div>,
      location: '/quoting/quotes',
      skip: () => !!window.location.href.match(/.+\/quoting\/quotes\/[0-9]+/gi) || !!window.location.href.match(/.+\/contacts\/manage\/.+\/quote\/[0-9]+/gi),
    },
    {
      target: '.quoteEditor-container .editablePivotTable-container .pivotTable-header-button.add-new-item',
      content: <div>The first thing we need to do is add our line items. To add a simple item to your quote <i>Tap This Button</i>.</div>,
    },
    {
      // Inline tooltip in item drawer
      dummy: true,
    },
    {
      target: '.quoteTotal-totals',
      content: "Now that you've populated your quote, check the total at the bottom.",
      actions: [
        {
          label: "Next",
          flat: true,
          primary: true,
          type: 'next',
        },
      ],
    },
    {
      target: '.quoteTotal-modifiers',
      content: "If you want, you can apply a discount to the whole quote by entering a number in the box below.",
      actions: [
        {
          label: "Learn More Skills",
          flat: true,
          type: 'skills',
        },
        {
          label: "Finish",
          flat: true,
          primary: true,
          type: 'finish',
        },
      ],
    },
  ],
}

export default skill
